export default __webpack_public_path__ + "static/media/med.05241866.svg";